import { render, staticRenderFns } from "./LabelsCard.vue?vue&type=template&id=4b66e3cb&scoped=true&"
import script from "./LabelsCard.vue?vue&type=script&lang=js&"
export * from "./LabelsCard.vue?vue&type=script&lang=js&"
import style0 from "./LabelsCard.vue?vue&type=style&index=0&id=4b66e3cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66e3cb",
  null
  
)

export default component.exports